import { getAllCoursesQuery } from '@pm2/course-builder';
import { useQueryWithNotifications } from '../notifications/hook.query-with-notifications.js';
import { groupNotificationsByEntryId } from '../notifications/util.group-notifications-by-entry-id.js';

function useCoursesWithNotifications(extraConfig) {
  return useQueryWithNotifications(getAllCoursesQuery.useQueryConfig({
    queryConfig: extraConfig
  }), mergeCourseWithNotification);
}
function mergeCourseWithNotification(courses, notifications) {
  const groupedNotifications = groupNotificationsByEntryId(notifications);
  return courses.map(rawCourse => {
    const relatedNotification = groupedNotifications.get(rawCourse.id)?.find(it => it.type === "share.course");
    if (relatedNotification) {
      return {
        ...rawCourse,
        shareNotification: relatedNotification
      };
    }
    return rawCourse;
  });
}

export { useCoursesWithNotifications };
//# sourceMappingURL=hook.courses-with-notifications.js.map
